import Vue from 'vue';
import VueResource from 'vue-resource';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import formatarData from '~js/formatar-data';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

function normalizarParaVisualizar(solicitacao) {
  solicitacao.dataCancelamento = formatarData.dataParaStr(solicitacao.dataCancelamento);

  return solicitacao;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    return Vue.http.get('/api/solicitacaocancelamentocontrato', { params: parametros });
  },
  adicionarAlterar: async (solicitacao, arquivos) => {
    solicitacao.arquivos = arquivos;
    solicitacao = converterObjetoFormData(solicitacao);

    return Vue.http.post('/api/solicitacaocancelamentocontrato', solicitacao).then(res => res.data.id);
  },
  obterPorId: async id => {
    return Vue.http.get(`/api/solicitacaocancelamentocontrato/${id}`)
      .then(response => response.data)
      .then(solicitacao => normalizarParaVisualizar(solicitacao));
  },
  liberar: id => {
    return Vue.http.post(`/api/solicitacaocancelamentocontrato/${id}/liberar`)
      .then(response => response.data);
  },
  cancelar: id => {
    return Vue.http.post(`/api/solicitacaocancelamentocontrato/${id}/cancelar`)
      .then(response => response.data);
  },
  arquivos: id => {
    return Vue.http.get(`/api/solicitacaocancelamentocontrato/${id}/arquivos`)
      .then(response => response.data);
  },
  download: (id, arquivo) => {
    return Vue.http.get(`/api/solicitacaocancelamentocontrato/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-cancelamento-contrato/servico.js